import { AvatarComponent } from './avatar.component';

export default angular
  .module('sfMobile.components.avatar', [])
  .component('sfAvatar', AvatarComponent).name;
